import { render } from "./ClientLogin.vue?vue&type=template&id=7dca1fe3"
import script from "./ClientLogin.vue?vue&type=script&lang=js"
export * from "./ClientLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__